module.exports = __webpack_public_path__ + "img/logo-min.9d7b5f7d.jpg";